import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import WellnessStateCircle from '@/components/molecules/WellnessStateCircle';
import { TMemberCareMember } from '@/types/MemberCare.types';

type Props = {
  member: TMemberCareMember;
};

const MemberTab = ({ member }: Props) => {
  const { ...wellnessData } = member.healthDomainScores ?? {};
  delete wellnessData.totalScore;

  return (
    <VStack>
      <Text variant="loraSmallTitle" color="text.mediumGray" fontWeight={'500'}>
        {member.firstName}'s Wellness Report
      </Text>
      <WellnessStateCircle
        wellnessData={wellnessData}
        userAvatar={member.profilePicture}
        averageScore={member.averageScore}
      />
    </VStack>
  );
};

export default MemberTab;
